// extracted by mini-css-extract-plugin
export default {"buttons-wrapper":"style_buttons-wrapper__pWCwl","buttonsWrapper":"style_buttons-wrapper__pWCwl"};